<svg xmlns="http://www.w3.org/2000/svg" width="105" height="177" preserveAspectRatio="none" viewBox="0 0 105 172">
  <defs>
    <linearGradient id="a" x1="50%" x2="50%" y1="41.129%" y2="66.71%">
      <stop offset="0%" stop-color="#D90338"/>
      <stop offset="100%" stop-color="#D90338"/>
    </linearGradient>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <path fill="url(#a)" d="M0 0h103.373v171.505H0z" transform="translate(1)"/>
  </g>
</svg>
